import { defineNuxtRouteMiddleware, navigateTo } from "nuxt/app"

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default defineNuxtRouteMiddleware(to => {
  return navigateTo("/studie/landing", {
    redirectCode: 301,
  })
})
